<template>
  <v-app-bar elevation="0" class="main-header" height="64" fixed color='primary' dark>
    <v-btn icon class="mx-1" @click.stop="TOGGLE_DRAWER">
      <template v-if="DRAWER_STATE">
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-arrow-left</v-icon>
      </template>
      <template v-else>
        <v-icon size="28" :class="$vuetify.theme.dark ? 'primary--text' : null">mdi-menu</v-icon>
      </template>
    </v-btn>
    <div>
      <router-link :to="{ path: `${domain.domainName}/index` }">
        <v-img lazy-src="https://www.ausa.com.mx/img/Ausa-logov3.png" max-height="80" max-width="50"
          src="https://www.ausa.com.mx/img/Ausa-logov3.png"></v-img>
      </router-link>
    </div>
    <v-spacer></v-spacer>
    <v-btn icon>
      <v-icon @click="validarBusqueda">mdi-magnify</v-icon>
    </v-btn>
    <div>
      <v-text-field class="mt-7" v-if="expandir" placeholder="Número de Siniestro" v-model="siniestro" maxlength="20"
        @keyup.enter="Buscar()" autofocus></v-text-field>
    </div>
    <v-menu min-width="180" offset-y bottom left nudge-bottom="10">
      <template v-slot:activator="{ on, attrs }">
        <v-avatar size="40" v-bind="attrs" v-on="on" class="mr-3">
          <img src="@/assets/img/hombre.png" alt="John">
        </v-avatar>
      </template>
      <v-list>
        <div class="d-flex justify-center my-3">
          <v-btn width="80%" large outlined color="primary" class="text-capitalize" @click="cerrarSesion()">Cerrar
            Sesión</v-btn>
        </div>
      </v-list>
      <v-list v-if="cambiopass">
        <div class="d-flex justify-center my-3">
          <v-btn width="80%" large outlined color="primary" class="text-capitalize" @click="PerfilUsuario()"
            style="font-size: 11px">Perfil del Usuario</v-btn>
        </div>
      </v-list>
    </v-menu>
    <div class="greeting-text mr-3 d-none d-md-block">{{ cliente }}&nbsp;{{ flotilla }}<v-spacer></v-spacer> Hola,
      <span>{{ nombre }}</span>
    </div>

  </v-app-bar>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import config from '@/config.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import router from '@/router'

export default {
  name: 'Header',
  components: {},
  data: () => ({
    config,
    searchCollapse: true,
    nombre: '',
    siniestro: '',
    buscarclose: true,
    cliente: '',
    flotilla: '',
    cambiopass: false,
    expandir: false,
  }),
  computed: {
    ...mapState({ drawer: state => state.drawer }),
    ...mapState(['domain', 'informationPage']),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
    }
  },
  methods: {
    ...mapActions(['TOGGLE_DRAWER']),

    async obtenerNombre() {
      let response = await this.axios.post(`${this.domain.domainNameForApi}ObtenerNombre`);
      this.nombre = response.data;
    },

    async obtenerClienteFlotilla() {
      let response = await this.axios.post(`${this.domain.domainNameForApi}ObtenerClienteGrupo`);
      let data = response.data.split("/");
      this.cliente = data[0];
      if (data.length == 2)
        this.flotilla = " /  " + data[1];
    },

    cerrarSesion() {
      // this.axios.post(`${this.domain.domainNameForApi}Server`).then(response => {

      //                 this.server = response.data;
      //             })
      MetodosGenerales.cerrarSesion(this.domain.domainNameForApi, this.informationPage);
    },
    PerfilUsuario() {
      this.$router.push({ name: "perfilusuario" }).catch((error) => error);
    },
    Buscar() {
      this.siniestro = this.siniestro.trim();
      if (this.siniestro != "") {
        var URLactual = window.location.href;
        let auxsiniestro = this.siniestro;
        this.siniestro = "";
        this.expandir = false;
        if (URLactual != this.domain.domainNameWithHttp + "BusquedaGeneral") {
          this.$router.push({
            name: "busquedageneral",
            params: { data: auxsiniestro },
          });
        } else {
          this.$root.$emit("busquedaSiniestro", auxsiniestro);
        }
      } else {
        this.$swal({
          position: "center",
          icon: "warning",
          title: "Error",
          text: "Debe de llenar este campo",
          showConfirmButton: true,
          allowOutsideClick: false,
          timer: 2500,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      }
    },
    async obtenerBloqueo() {
      let password = await MetodosGenerales.obtenerSessionReporte("password");
      this.cambiopass = password.tipo != "OK" ? true : false;
    },
    validarBusqueda() {
      if (this.siniestro != "") {
        this.Buscar();
      } else {
        this.expandir = !this.expandir;
      }
    },
  },
  mounted() {
    this.obtenerNombre();
    this.obtenerClienteFlotilla();
    this.obtenerBloqueo();
  },
};
</script>

<style src="@/views/shared/header/Header.scss" lang="scss"></style>
